import React, { useContext } from 'react';
import { Checkbox, Divider, Form, Radio, Segmented, Space, Typography } from 'antd';
import { MCPResearchContext } from '../MCPResearchUI';
import { ANTD_SPACE } from '../../Helper/Constant';
import { formKeys } from '../MCPServerConstants';

const { Text, Title } = Typography;

const Attributes = () => {
    const { mcpAppDetails } = useContext(MCPResearchContext);
    return (
        <div>
            {/* Attributes Outer */}
            <div className='ns-flex ns-flex_vertical ns-flex_gap'>
                {/* Attributes Inner */}
                {Object.values(mcpAppDetails.questionCategories).map((category) => (
                    /* Attributes Group */
                    <div
                        key={category.category_name}
                        className='ns-flex ns-flex_gap ns-card-border-radius ns-border-small ns-padding-medium'
                    >
                        <Title level={5} style={{ width: '20%' }}>
                            {category.category_text}
                        </Title>
                        <AttributeSection category={category} />
                    </div>
                ))}
            </div>
        </div>
    );
};

const AttributeSection = ({ category }) => {
    const optionLabel = (question) => {
        return (
            <div>
                <Text>{question.question_text}</Text>
            </div>
        );
    };

    if (!category.multi_valued) {
        const options = category.questions.map((question) => ({ label: optionLabel(question), value: question.question_col_name }));
        return (
            <div>
                <Form.Item name={[formKeys.attrCategory, category.category_name]}>
                    <Segmented options={options} defaultValue={''} />
                </Form.Item>
            </div>
        );
    }

    return (
        <div>
            <Form.Item name={[formKeys.attrCategory, category.category_name]}>
                <Checkbox.Group style={{ width: '100%' }}>
                    <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                        {category.questions.map((question) => (
                            <Checkbox key={question.question_col_name} value={question.question_col_name}>
                                {optionLabel(question)}
                            </Checkbox>
                        ))}
                    </Space>
                </Checkbox.Group>
            </Form.Item>
        </div>
    );
};

export default Attributes;
